import React, { useState } from "react";
import { Modal, Header, Button, Loader, Dimmer, Image, Grid, Input } from "semantic-ui-react";
import "./MissingSkuModal.css";
import TimerDisplay from "../TimerDisplay/TimerDisplay";
import { ISortBoxItemModel } from "../../lib/SortBoxItem/ISortBoxItemModel";

interface IProps {
  onCloseClearState: () => void,
  boxItem: ISortBoxItemModel;
  missingSkuSetVerifiedQuantity: (missingAmount: number | null, boxItem: ISortBoxItemModel) => void,
  reservedQuantityIsMaxMissing: boolean
}
const MissingSkuModalSelectMissing = ({
  onCloseClearState,
  boxItem,
  missingSkuSetVerifiedQuantity,
  reservedQuantityIsMaxMissing: reservedQuantityIsMaxMissing = false
}: IProps) => {
  const [missingAmount, setMissingAmount] = useState(0);
  const missingAmountMax = (reservedQuantityIsMaxMissing) ? boxItem.reservedQuantity : boxItem.reservedQuantity - boxItem.verifiedQuantity;
  var numberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    var target = e.target;
    var val = 0;
    try {
      val = parseInt(target.value);
    } catch {
      val = 0;
    }
    if (val < 0) {
      val = 0;
    }

    if (val !== 0) {
      if (val > missingAmountMax) {
        val = missingAmountMax;
      }
    }
    target.value = val ? val.toString() : "";
    setMissingAmount(val);
  };
  return (
    <Modal
      open={true}
      className="MissingSkuModal"
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
      closeOnEscape={false}
    >
      <Header>
        <Header.Content className="skuModalContent">
          <Grid>
            <Grid.Column width={4}></Grid.Column>
            <Grid.Column width={8}>
              <h2>{"Artikel saknas"}</h2>
            </Grid.Column>
            <Grid.Column className="timerColumn" width={4}>
              <TimerDisplay timer="missingskutimer" type={3} trigger={boxItem.skuID} />
            </Grid.Column>
          </Grid>
          <div className={"ArticleInfo"}>
            <div className="ArticleInfoText">
              <div className="ArticleInfoTextName">
                <b>{boxItem.name}</b>
              </div>
              <div className="ArticleInfoTextName">
                SkuID:
                <span style={{ marginLeft: "10px" }}>{boxItem.skuID}</span>
              </div>
              {boxItem.pickedBy > 0 && (
                <div className="PickedByText">
                  Plockad av <b>{boxItem.pickedByName}</b>
                </div>
              )}
              {(boxItem.rxIsNarc) ? (<div>
                <span style={{color: "red", float:"left", marginTop: "50px", position:"absolute", zIndex: 3}}>
                  <b style={{ fontSize: "1.5em" }}>Nark-vara!</b>
                </span>
              </div>) :null}
            </div>
            <div className="ImageWrapper">
              <Image
                size="tiny"
                src={boxItem.imageURL}
                onError={(e: any) => (e.currentTarget.src = "https://placehold.co/280x280")} />
            </div>
          </div>
        </Header.Content>
      </Header>
      <Modal.Content>
        <div className="Subtitle">Ange saknat antal:</div>
        <Input className="Subtitle" type="number" style={{ width: "120px", marginLeft:'40%'}}  onChange={numberChange} />
      </Modal.Content><Modal.Actions>
        <Button secondary onClick={onCloseClearState} floated={"left"}>
          AVBRYT
        </Button>
        <Button
          primary
          onClick={() => missingSkuSetVerifiedQuantity(missingAmount, boxItem)}
        >
          BEKRÄFTA
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default MissingSkuModalSelectMissing;
